exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "datepicker .input-field input{width:100%}datepicker .input-field .opener{position:absolute;top:0;right:0;margin-top:4px;cursor:pointer}", ""]);
